export default __webpack_public_path__ + "static/media/footer-banner.30af3d99.webp";